// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"64":"football","133":"layout","204":"system","570":"basketball","806":"user","823":"sport","966":"login","993":"welfare"}[chunkId] + "." + {"64":"e3d9db1d","133":"7ee5f37a","204":"a5cdafc9","570":"53c53566","806":"6fd7828e","823":"74b08091","966":"507b3e00","993":"51429141"}[chunkId] + ".css";
};